// extracted by mini-css-extract-plugin
module.exports = {"outlined":"_view_outlined__1SzyQ"};